// extracted by mini-css-extract-plugin
export var calendarView = "_mr-0";